var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"persistenceKey":'survey-list',"setLoading":_vm.setLoading,"loadDataGrid":_vm.loaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }